export default {"src":"/polygon/_next/static/media/quickswap.3e457157.svg","height":48,"width":48};